<template>
  <div
    class="modal-card"
  >
    <vue-recaptcha
      ref="recaptcha"
      :sitekey="siteKey"
      size="invisible"
      @verify="submit"
      @expired="onCaptchaExpired"
    />
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t('messages.please_fill_info') }}</p>
    </header>
    <section class="modal-card-body">
      <div>
        <b-field :label="$t('register.email')">
          <b-input
            v-validate="'required|email'"
            v-model="email"
            :placeholder="$t('forgot_password.email_placeholder')"
            name="email"
            type="text"
            @keyup.enter.native="executeRecaptcha"
          />
        </b-field>
        <span class="is-invalid">{{ errors.first('email') }}</span>
      </div>
    </section>
    <footer class="modal-card-foot">
      <button
        class="button"
        type="button"
        @click="$emit('close')"
      >
        {{ $t('messages.close') }}
      </button>
      <button
        class="button is-primary"
        @click="executeRecaptcha"
      >
        {{ $t('buttons.submit') }}
      </button>
    </footer>
  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
import { RECAPTCHA_SITE_KEY } from '@/constants'

export default {
  name: 'RequestEmailModal',
  inject: ['$validator'],
  components: {
    VueRecaptcha
  },
  data: () => ({
    email: '',
    siteKey: RECAPTCHA_SITE_KEY
  }),
  methods: {
    executeRecaptcha () {
      this.$refs.recaptcha.execute()
    },
    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
    },
    async submit (recaptchaToken) {
      const validateFieldResult = await this.$validator.validate()
      if (validateFieldResult) {
        this.$emit('getEmail', this.email, recaptchaToken)
        this.$refs.recaptcha.reset()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RequestEmailModal.vue